// Make sure to prefix the mutation names with the module to avoid collisions
export const CALENDAR_SET_CALENDAR = 'calendarSetCalendar'
export const CALENDAR_LOADING_CALENDARS = 'calendarsLoadingCalendars'
export const CALENDAR_SET_CALENDARS = 'calendarSetCalendars'
export const CALENDAR_SET_EVENT_SOURCES = 'calendarSetEventSources'
export const CALENDAR_SET_CALENDAR_TYPES = 'calendarSetCalendarTypes'
export const CALENDAR_OPEN_DELETE_CALENDAR_EVENT_MODAL = 'calendarOpenDeleteCalendarEventModal'
export const CALENDAR_CLOSE_DELETE_CALENDAR_EVENT_MODAL = 'calendarCloseDeleteCalendarEventModal'
export const CALENDAR_OPEN_SET_VISIBILITY_MODAL = 'calendarOpenSetVisibilityModal'
export const CALENDAR_CLOSE_SET_VISIBILITY_MODAL = 'calendarCloseSetVisibilityModal'
export const CALENDAR_OPEN_CREATE_CALENDAR_SOURCE_MODAL = 'calendarOpenCreateCalendarSourceModal'
export const CALENDAR_CLOSE_CREATE_CALENDAR_SOURCE_MODAL = 'calendarCloseCreateCalendarSourceModal'
export const CALENDAR_OPEN_EDIT_CALENDAR_SOURCE_MODAL = 'calendarOpenEditCalendarSourceModal'
export const CALENDAR_CLOSE_EDIT_CALENDAR_SOURCE_MODAL = 'calendarCloseEditCalendarSourceModal'
export const CALENDAR_OPEN_DELETE_CALENDAR_SOURCE_MODAL = 'calendarOpenDeleteCalendarSourceModal'
export const CALENDAR_CLOSE_DELETE_CALENDAR_SOURCE_MODAL = 'calendarCloseDeleteCalendarSourceModal'